import React, { useEffect, useRef, useState } from 'react';

const VideoPlayerModal = ({ open, src, poster, onClose }) => {
  const vref = useRef(null);
  const [nat, setNat] = useState({ w: 1280, h: 720 });
  const [vw, setVw] = useState(window.innerWidth);
  const [vh, setVh] = useState(window.innerHeight);
  useEffect(() => {
    const handle = () => { setVw(window.innerWidth); setVh(window.innerHeight); };
    window.addEventListener('resize', handle);
    return () => window.removeEventListener('resize', handle);
  }, []);
  const onMeta = () => {
    const el = vref.current;
    if (!el) return;
    const nw = el.videoWidth || nat.w;
    const nh = el.videoHeight || nat.h;
    setNat({ w: nw, h: nh });
  };
  const availW = vw * 0.9;
  const availH = vh * 0.85;
  let dispW = Math.min(nat.w, availW);
  let dispH = (dispW * nat.h) / nat.w;
  if (dispH > availH) {
    dispH = Math.min(nat.h, availH);
    dispW = (dispH * nat.w) / nat.h;
  }
  dispW = Math.round(dispW);
  dispH = Math.round(dispH);
  if (!open) return null;
  return (
    <div
      className="video-modal"
      onClick={onClose}
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, overflow: 'auto' }}
    >
      <div
        className="video-modal__content"
        onClick={(e) => e.stopPropagation()}
        style={{ position: 'relative', background: '#0a0d12', border: '1px solid #334155', borderRadius: 10, padding: 10 }}
      >
        <div style={{ position: 'relative', width: `${dispW}px`, height: `${dispH}px` }}>
          <video
            src={src}
            controls
            autoPlay
            playsInline
            preload="auto"
            poster={poster}
            onLoadedMetadata={onMeta}
            ref={vref}
            style={{ display: 'block', width: '100%', height: '100%' }}
          />
          <button
            className="video-modal__close"
            onClick={onClose}
            aria-label="Close"
            style={{ position: 'absolute', top: 6, right: 6, width: 32, height: 32, borderRadius: 8, border: '1px solid #334155', background: 'rgba(31,41,55,0.85)', color: '#e5e7eb', display: 'grid', placeItems: 'center' }}
          >
            ×
          </button>
        </div>
      </div>
    </div>
  );
};

export default VideoPlayerModal;
